import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.SENTRY_DSN,
  release: environment.versionNumber,
  environment: environment.production ? 'production' : 'dev',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
  ],
})

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
